import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Button } from '@mui/material'
import { Print } from '@mui/icons-material'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'

import { useGET_meetingByIdQuery, useGET_meetingProtocolByIdQuery } from 'redux/api/meetingsApi'
import { printDiv, formatDateTime } from 'utils/helpers'

const MeetingReportCrudPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const backToSlug ='/meeting-reports'

  const params = useParams()
  const id = params?.id

  const { data } = useGET_meetingProtocolByIdQuery(id.toString())
  const { data: meeting } = useGET_meetingByIdQuery(id.toString())

  return (
    <>
      <PageHeading title={`${t('meetings.meeting-reports')}`} />
      <PageBody>
        <Box className="thick-border" sx={{ display: 'inline-block'}}>
            {
              data && meeting && <>
                <div id="info-table">
                  <table className="info-table"><tbody>
                    <tr><td>{ t('common.start-date-time') }:</td><td>{ formatDateTime(data.start_datetime) }</td></tr>
                    <tr><td>{ t('common.duration-minutes') }:</td><td>{ data.duration_minutes }</td></tr>
                    <tr><td>{ t('meetings.facilitator') }:</td><td>{ typeof meeting.facilitator === 'string' ? meeting.facilitator : meeting.facilitator.type }</td></tr>
                    <tr><td>{ t('meetings.note-taker') }:</td><td>{ typeof meeting.note_taker === 'string' ? meeting.note_taker : meeting.note_taker.type }</td></tr>
                    <tr><td>{ t('meetings.location') }:</td><td>{ data.location }</td></tr>
                    <tr><td>{ t('meetings.purpose') }:</td><td>{ meeting.purpose }</td></tr>
                    <tr><td>{ t('meetings.agenda') }:</td><td><span dangerouslySetInnerHTML={{ __html: data.agenda }} /></td></tr>
                    <tr><td>{ t('meetings.notes') }:</td><td><span dangerouslySetInnerHTML={{ __html: data.notes }} /></td></tr>
                  </tbody></table>
                </div> 

                <Button
                      variant='outlined'
                      color='black'
                      onClick={() => navigate(backToSlug)}
                      sx={{ minHeight: '2.5rem', width: '10rem' }}
                    >
                      {`${t('common.back')}`}  
                </Button>
                <Button
                      variant='contained'
                      color='success'
                      onClick={ () => { printDiv('info-table') } }
                      sx={{ minHeight: '2.5rem', width: '10rem', marginLeft: '10px' }}
                    >
                      <Print style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                      {`${t('common.print')}`}
                </Button>
              </>
            }
          

        </Box>
      </PageBody>
    </>
  )
}
export default MeetingReportCrudPage
